export default "__VITE_ASSET__DQoB2S7g__";